// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';


class AddTournamentFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      competitions_id:props.competitions_id,
      teams: [],
      venues:[],
      match_types: {},
      match_details: {
        start_date: moment(),
        start_time: '',
        end_time: '',
        match_type: '',
        team_one: '',
        team_two: '',
        tournament_id: '',
        mobile_no: '',
        buddy_id: '',
      },
      data_uploaded: false,
      data_error: false,
      buddy_search_list: [],
      buddies: [],
      search: false,
      addFixtureView:false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.searchBuddy = this.searchBuddy.bind(this);

    this.styles = {
          chip: {
            margin: 4,
          },
          wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
          },
        };
  }


  componentDidMount() {
    this.getTournamentTeamDetails();
    console.log(this.state);
  }

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({buddy_search_list: data.results, search: true}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  searchBuddy() {
    {this.state.match_details.mobile_no?this.getSearchList(this.state.match_details.mobile_no):
      alert('Search cannot be blank')}
  }

  setSearch(name, mobile, id){
    var new_selected_one =  Object.assign({}, this.state.match_details);
    var buddies = Object.assign([], this.state.buddies);
    buddies.push({'id': id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png"});
    new_selected_one['mobile_no'] = mobile
    new_selected_one['name'] = name
    new_selected_one['buddy_id'] = id
    this.setState({match_details: new_selected_one, search: false, buddies: buddies});

  }

  getTournamentTeamDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_match_input_for_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'competition_id': this.state.competitions_id
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState(
         { teams: data.teams,
           match_types: data.match_types,
           venues:data.venues
         });
        })
       .catch(error => error);
  }

  postaddMatch(data, props) {
    if(!data.match_type){data.match_type=Object.keys(this.state.match_types)[0]}
    if(!data.team_one){data.team_one=this.state.teams[0].id}
    if(!data.team_two){data.team_two=this.state.teams[0].id}
    if(!data.venue){data.venue = this.state.venues[0].id}
    const url = `${getLocationOrigin()}/eagleeye/create_tournament_match/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'competition_id':this.state.competitions_id,
                        'start_date': data.start_date,
                        'start_time': data.start_time,
                        'end_time': data.end_time,
                        'match_type': data.match_type,
                        'team_one': data.team_one,
                        'team_two': data.team_two,
                        'venue_id':data.venue,
                        'buddies': this.state.buddies,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          window.location.reload();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.match_details);
    new_selected_one[name] = event.target.value
    this.setState({match_details: new_selected_one});
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.match_details);
    new_selected_one['start_date'] = date
    this.setState({match_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddMatch(this.state.match_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleRequestDelete = (key) => {
    var buddies = Object.assign([], this.state.buddies);
    console.log(buddies);
    const chipToDelete = buddies.findIndex(chip => chip.id==key);
    buddies.splice(chipToDelete, 1);
    this.setState({buddies: buddies});
  };
  toCreateFixtureView(){
    this.setState({addFixtureView:!this.state.addFixtureView})
  }

  renderChip(data) {
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data.id)}
        style={this.styles.chip}
      >
        <Avatar id={data.id} src={data.photo=='http://www.sporthood.in/assets/img/avatar.png'?data.photo:
        `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  render() {
    return(
      <div >
      {/*<div><input className="button1" type="button" value="Add Match" onClick={() => {this.toCreateFixtureView()}} /></div>
      {this.state.addFixtureView && 
      <Dialog
                                        modal={false}
                                        open={true}
                                        autoDetectWindowHeight={true}
                                        autoScrollBodyContent={true}
                                        scroll={scroll}
                                        dividers={scroll === 'paper'}
                                        style={{width:'115%'}}
                                      >*/}
        <div  style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Match</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.match_details.start_date} onChange={this.handleStartDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team One
              </div>
              <select name="team_one" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.teams.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team Two
              </div>
              <select name="team_two" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.teams.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Match Type
              </div>
              <select name="match_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  Object.keys(this.state.match_types).map((key, index) => (
                  <option key={index} value={key}>{this.state.match_types[key]}</option>
                  ))
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {this.state.venues.map((venue,index) =>
                  <option key={index} value={venue.id}>{venue.name}</option>
                  )
                  
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} name="start_time" value={this.state.value}
                onChange={this.handleChange} placeholder="19:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" value={this.state.value}
                onChange={this.handleChange} placeholder="20:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddy Search
              </div>
              <div className="col-md-6 input-group" style={{width:'60%'}}>
                <input  type="text" name="mobile_no" className="form-control"
                  placeholder="Search for.. " value={this.state.match_details.mobile_no} onChange={this.handleChange}/>
                <span className="input-group-btn">
                  <button className="btn btn-default glyphicon glyphicon-search"
                  type="button" onClick={this.searchBuddy}></button>
                </span>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              {this.state.search?
                <div className="col-md-12 btn-group">
                  {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.id} className="btn btn-default"
              style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.mobile_no, x.id)}>{x.name}:{x.mobile_no}</button>))
              :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                  <div>Search buddy not found</div>
              </div>}</div>:''}
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Selected Buddies
              </div>
              <div className="col-md-6" style={styles.item_body}>
                <div style={this.styles.wrapper}>
                  {this.state.buddies.map(this.renderChip, this)}
                </div>
              </div>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input type="button" className="button1" value="Cancel" style={{backgroundColor:'red',color:'#ffffff'}} onClick={() => {this.toCreateFixtureView()}} />
            </div>
            
          </form>
        </div>
        {/*</Dialog>*/}
      </div>

    );
  }
}

export default AddTournamentFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentFixture/index.js